export default "__VITE_ASSET__BKeonen4__"